import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heading from "../../../../../common/element/Heading";
import Dialog from "../../../../../common/element/Dialog/Dialog";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import BtnPrimary from "../../../../../common/element/Buttons/btnPrimary";
import Table from "../../../../../common/element/Table";
import * as userActions from "../../../../../actions/index";
import ReactPaginate from "react-paginate";
import searchIcon from "../../../../../assets/icons-svg/search-lg.svg";
import plusIcon from "../../../../../assets/icons-svg/plus.svg";
import fileCheck from "../../../../../assets/icons-svg/file-check.svg";
import Validations from "../../../../../common/404/Validations";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import { debounce } from "../../../../../common/snippet/Debouncing";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
import { Pagination } from "../../../../../common/pagination";
import ThreeDotLoader from "../../../../../common/element/ButtonLoader/ThreeDotLoader";
import ThreeDotBouncing from "../../../../../common/element/PageLoader";

const DocCategories = () => {
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();

  const loginData = JSON.parse(localStorage.getItem("LoginUserData"));
  let permission_info;
  if (loginData?.data != null) {
    permission_info = JSON.parse(localStorage.getItem("permissionData"));
  }

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [filtersort, setFiltersort] = useState("document_types_category_id");
  const [filterorder, setFilterOrder] = useState("asc");
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [searchTerm, setsearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState(0);

  const [categoryData, setCategoryData] = useState([]);

  const [dialogIsOpen, setIsOpen] = useState(false);
  const [dialogAddOpen, setAddOpen] = useState(false);

  const [category, setCategory] = useState("");
  const [formErrors, setFormErrors] = useState({
    category: "",
  });

  const { Tr, Th, Td, THead, TBody } = Table;

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Doc Categories",
          url: "/admin/doc-categories",
          home: "/admin/dashboard",
        },
      ])
    );
  }, []);

  const openDialog = () => {
    if (!buttonDisabled) {
      setIsOpen(true);
    }
  };

  const clearForm = () => {
    setCategory("");
    setFormErrors({ category: "" });
  };

  const onDialogClose = () => {
    if (!buttonDisabled) {
      setIsOpen(false);
      clearForm();
    }
  };

  const openAddDialog = () => {
    setAddOpen(true);
    setIsOpen(false);
  };

  const onAddDialogClose = () => {
    setAddOpen(false);
    AdminGetAllDocumentCategories();
  };

  const handleSort = (column) => {
    if (column === filtersort) {
      setFilterOrder(filterorder === "asc" ? "desc" : "asc");
    } else {
      setFiltersort(column);
      setFilterOrder("asc");
    }
  };

  const handlePageChange = ({ selected }) => {
    setfilterpage(selected + 1);
  };

  const handleSeachChange = (e) => {
    setsearchTerm(e.target.value.trim());
    setfilterpage(1);
  };
  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);

  const AdminGetAllDocumentCategories = useCallback(async () => {
    dispatch(
      userActions.AdminGetAllDocumentCategories(
        searchTerm,
        filterpage,
        filterorder,
        filtersort,
        filterlimit
      )
    )
      .then((response) => {
        if (response?.success === true) {
          const rows = response?.data?.rows || [];
          setCategoryData(rows);
          setCountData(response?.data?.count || 0);
          setTotalPages(Math.ceil((response?.data?.count || 0) / filterlimit));
          setLoadData(true);
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
          setLoadData(true);
        } else {
          setLoadData(true);
        }
      })
      .catch((error) => {
        setLoadData(true);
        console.error("Error:", error);
      });
  }, [
    dispatch,
    searchTerm,
    filterpage,
    filterorder,
    filtersort,
    filterlimit,
  ]);

  useEffect(() => {
    AdminGetAllDocumentCategories();
  }, [searchTerm, filterpage, filterorder, filtersort, filterlimit]);

  const submitCategory = (e) => {
    e.preventDefault();

    const validation = Validations({
      value: category,
      Validations: { required: true },
    });

    if (!validation.valid) {
      setFormErrors({ category: validation.error_msg });
      return;
    }

    setButtonDisabled(true);
    dispatch(userActions.AddDocumentCategory({ category }, ipAddress))
      .then((response) => {
        if (response?.success === true) {
          clearForm();
          setButtonDisabled(false);
          onDialogClose();
          openAddDialog();
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
        } else {
          if (response?.status === 409) {
            setFormErrors({ category: response?.message || "Already exists" });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };

  return (
    <React.Fragment>
      <div className="flex items-center justify-between mb-7 gap-3">
        <Heading>Document Categories</Heading>
        {permission_info && permission_info?.role_name !== "support team" && (
          <BtnPrimary
            onClick={() => openDialog()}
            className="w-48 flex items-center justify-center text-12"
            variant="solid"
          >
            Add document category
            <span className="ml-3">
              <img src={plusIcon} alt="" className="h-5" />
            </span>
          </BtnPrimary>
        )}
      </div>

      <div className="flex justify-between mb-5 flex-wrap gap-y-2.5">
        <div className="flex gap-2">
          <div className="w-80 h-10">
            <div className="input-wrapper">
              <div className="input-suffix-start left-3.5">
                <img src={searchIcon} alt="" className="h-5" />
              </div>
              <input
                type="text"
                name="hs-table-search"
                className="input  pl-11 w-full  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Search"
                onChange={(e) => inputchangeSearch(e)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        <div className=" border rounded-lg border-gray-200">
          <Table>
            <THead>
              <Tr>
                <Th>
                  <span
                    className="flex items-center gap-1"
                    onClick={() => handleSort("category")}
                  >
                    Document Categories
                    <svg
                      className={`transform ${
                        filtersort === "category" && filterorder === "asc"
                          ? "rotate-180"
                          : ""
                      }`}
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                        stroke="#475467"
                        strokeWidth="1.333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Th>
              </Tr>
            </THead>
            <TBody>
              {categoryData &&
                categoryData.map((item, index) => (
                  <Tr key={index}>
                    <Td>{item?.category || "-"}</Td>
                  </Tr>
                ))}
            </TBody>
          </Table>
        </div>
      </div>

      {!loadData && (
        <div>
          <ThreeDotBouncing />
        </div>
      )}

      {loadData && (
        <div className="flex justify-between mt-3">
          <Pagination
            totalCount={countData}
            pageNumber={filterpage}
            displayPage={categoryData?.length}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />
          {countData > 0 && (
            <ReactPaginate
              className="flex justify-content-end p-2 align-items-center pagination-wrap"
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              previousLinkClassName={"prev-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"prev-link"}
              previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
              nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
              pageLinkClassName={"px-4 rounded-md"}
              activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
              disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
              renderOnZeroPageCount={null}
              forcePage={filterpage - 1}
            />
          )}
        </div>
      )}

      <Dialog
        isOpen={dialogIsOpen}
        onClose={onDialogClose}
        onRequestClose={onDialogClose}
        bodyOpenClassName="overflow-hidden"
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src={fileCheck} alt="" />
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              Add Document Category
            </h5>
          </div>
        </div>
        <div className="px-6">
          <div className="flex mb-5">
            <label className="font-medium text-gray-700 w-1/5">
              Document category
            </label>
            <div className="w-4/5 pl-2">
              <input
                type="text"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter document category here"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              />
              {!category && formErrors.category && (
                <p className="text-xs text-red-600 mt-2">{formErrors.category}</p>
              )}
              {category && formErrors.category && (
                <p className="text-xs text-red-600 mt-2">{formErrors.category}</p>
              )}
            </div>
          </div>
        </div>
        <div className="flex dailog-footer ">
          <BtnLight
            disabled={buttonDisabled}
            className="mr-1.5"
            variant="plain"
            onClick={onDialogClose}
          >
            Cancel
          </BtnLight>
          <BtnPrimary
            disabled={buttonDisabled}
            onClick={(e) => submitCategory(e)}
            className="ml-1.5"
          >
            {buttonDisabled ? <ThreeDotLoader /> : "Add"}
          </BtnPrimary>
        </div>
      </Dialog>

      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9.5 16l2 2 4.5-4.5M14.5 2H9.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4.5 4.28 4.5 5.12 4.5 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.78 22 7.62 22 9.3 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8l-6-6z"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Document category added
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={onAddDialogClose}>Close</BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default DocCategories;
